export default __webpack_public_path__ + "static/media/Logo.dfc1b5f0.png";